import { ApplicationLink, ApplicationLinkResult } from "../../interfaces/applicationlink";

export function mapLinkResponseToLinkService(response: any): ApplicationLinkResult {


    let model = {
        links: [] as ApplicationLink[],
    };

    if (response != null && Array.isArray(response)) {
        model.links = response.map((s: any) => ({
            name: s.name,
            title: s.title,
            parent: s.parent,
            fullurl: s.fullurl,
            section: s.section,
            target: s.target,
            linktargetframe: s.linktargetframe,
            displayorder: s.displayorder,
            children: s.children,
        }));
    }

    return model as ApplicationLinkResult;


}